import { render } from "./search-title.vue?vue&type=template&id=5e5ed8ec"
import script from "./search-title.js?vue&type=script&lang=js"
export * from "./search-title.js?vue&type=script&lang=js"

import "./search-title.vue?vue&type=style&index=0&id=5e5ed8ec&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__